// bodyClipLoaderRef — a tiny module-level handle to the active BodyClipLoader.
//
// The render-loop hot path (GraphEvaluator's missing-action branch, GestureChannel)
// needs to ask "pull this clip to the front of the load queue" without prop-
// drilling through React or importing AvatarModel. AvatarModel sets the loader
// here once the avatar is ready; consumers read it. This is deliberately NOT
// React state / context — it must be readable from useFrame without a re-render
// (same pattern as graphState / smRuntime module singletons).

let current = null

export function setBodyClipLoader(loader) { current = loader }
export function getBodyClipLoader() { return current }

// Convenience object form mirroring other module refs in this codebase.
export const bodyClipLoaderRef = {
  set: setBodyClipLoader,
  get: getBodyClipLoader,
}
